module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" ERP Journal Pooling (Log) ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Status")]), _vm._v(" "), _c('Select', {
    attrs: {
      "clearable": ""
    },
    on: {
      "on-change": _vm.getERPJournalPooling
    },
    model: {
      value: (_vm.filterStatus),
      callback: function($$v) {
        _vm.filterStatus = $$v
      },
      expression: "filterStatus"
    }
  }, _vm._l((_vm.dataStatuses), function(status, idx) {
    return _c('Option', {
      key: idx,
      attrs: {
        "value": status.type
      }
    }, [_vm._v("\n                            " + _vm._s(status.name) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "17"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingSearch),
      expression: "isLoadingSearch"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', [_c('Table', {
    attrs: {
      "columns": _vm.tableColumns,
      "data": _vm.dataPooling
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-046035d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/logs/ERPJournalPooling.vue
// module id = 1771
// module chunks = 1